/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_New_EntryInputs */

const fr_changelog_new_entry = /** @type {(inputs: Changelog_New_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle entrée`)
};

/**

* @param {Changelog_New_EntryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_new_entry = /** @type {((inputs?: Changelog_New_EntryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_New_EntryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_new_entry(inputs)
});